module.exports = __webpack_public_path__ + "img/xiaotu2.cb9e4693.png";